export default [
    {
        path:'detail/:coursewareBaseId/:classId',
        component(resolve) {
            require(['@/components/student/courseware/detail'], resolve)
        },
        meta: {
            title : '课节详情'
        }
    },
	//课堂报告被取代，旧的后期可以去除  zmf
    {
        path:'report/:coursewareId',
        component(resolve) {
            require(['@/components/student/courseware/detail'], resolve)
        },
        meta: {
            title : '课程报告'
        }
    },
    {
        path:'index/:coursewareId/:classId',
        component(resolve) {
            require(['@/components/student/courseware/index'], resolve)
        },
        meta: {
            allowBack: false,
            title : '智慧教室'
        }
    },
    {
        path:'res/board/:coursewareFileId',
        component(resolve) {
            require(['@/components/student/courseware/board'], resolve)
        },
        meta: {
            title : '白板板书'
        }
    },
    {
        path:'quiz/:coursewareId',
        component(resolve) {
            require(['@/components/student/courseware/quiz'], resolve)
        },
        meta: {
            allowBack: false,
            title : '课堂答题'
        }
    },
	//zmf 增加作为 单条问答，进入
	{
		path:'quiz/:coursewareId/:quizId',
		component(resolve) {
			require(['@/components/student/courseware/quiz'], resolve)
		},
		meta: {
			title : '课堂答题'
		}
	},
    {
        path:'res/screen/:coursewareId',
        component(resolve) {
            require(['@/components/student/courseware/screen'], resolve)
        },
        meta: {
            title : '课程截图'
        }
    },
    {
        path:'responder/:coursewareId/:rushAnswerId',
        component(resolve) {
            require(['@/components/student/courseware/responder'], resolve)
        },
        meta: {
            title : '抢答'
        }
    },
    {
        path:'responder-result/:rushAnswerId',
        component(resolve) {
            require(['@/components/student/courseware/responder-result'], resolve)
        },
        meta: {
            title : '抢答'
        }
    }
]





// WEBPACK FOOTER //
// ./src/router/student/courseware.js